import '../resources/css/contacts.css';
import Separator from './shared/Separator';

export default function Contacts({ data }) {

    if (!data?.content?.title) { return null; }

    const context = { ...data.content };

    return (
        <div className="contacts-wrapper" style={{ backgroundImage: `url(${context.backImage})` }}>
            <div className="contacts-container">
                <div className="column"></div>
                <div className="column">
                    <div className="title-h2 text-center">
                        {context.title}
                    </div>
                    <p className="text-center">
                        {context.description}
                    </p>
                    <div>
                        <Separator className="color-blue"></Separator>
                    </div>
                    <p>
                        <i className="fa fa-home"></i>
                        {context.address}
                    </p>
                    <p>
                        <i className="fa fa-phone"></i>
                        {context.phone}
                    </p>
                    <p>
                        <a href={'mailto:' + context.email}>
                            <i className="fa fa-envelope"></i>
                            {context.email}
                        </a>
                    </p>
                    <p>
                        <i className="fa fa-globe"></i>
                        {context.url}
                    </p>
                    <p>
                        <a href={context.facebook.url} target="_blank" rel="noreferrer">
                            <i className="fa fa-facebook"></i>
                            {context.facebook.text}
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}